function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M22.5 19.2h-.6V18h.6c.8 0 1.4-.6 1.4-1.4V6.5c0-.8-.6-1.4-1.4-1.4H6.1c-.8 0-1.4.6-1.4 1.4v.6H3.5v-.6c0-1.4 1.2-2.6 2.6-2.6h16.4c1.4 0 2.6 1.2 2.6 2.6v10.1c0 1.4-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M19.9 21.8H3.5c-1.4 0-2.6-1.2-2.6-2.6V9.1c0-1.4 1.2-2.6 2.6-2.6h16.4c1.4 0 2.6 1.2 2.6 2.6v10.1c0 1.5-1.2 2.6-2.6 2.6zM3.5 7.7c-.8 0-1.4.6-1.4 1.4v10.1c0 .8.6 1.4 1.4 1.4h16.4c.8 0 1.4-.6 1.4-1.4V9.1c0-.8-.6-1.4-1.4-1.4H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M13.5 14H5.2c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6h8.4c.9 0 1.6.7 1.6 1.6s-.8 1.6-1.7 1.6zm-8.3-2.1c-.2 0-.4.2-.4.4s.2.4.4.4h8.4c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H5.2zM10.9 18.2H5.2c-.9 0-1.6-.7-1.6-1.6S4.3 15 5.2 15H11c.9 0 1.6.7 1.6 1.6s-.8 1.6-1.7 1.6zm-5.7-2.1c-.2 0-.4.2-.4.4s.2.4.4.4H11c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H5.2z"
  }));
}
export default SvgCase;